<template>
  <div class="post-content">
    <div class="user-info">
      <div class="avatar">
        <img :src="resourceUrl(postObj.userAvatar,'avatar')">
      </div>
      <div class="username-time">
        <div class="username">{{postObj.nickName}}</div>
        <div class="time">{{ postObj.createTime }}</div>
      </div>
      <div class="detail" @click="postClick">
        详情
      </div>
    </div>
    <div :class="{'post-area-hidden' : hiddenFlag ,'post-area' : !hiddenFlag}">
      {{postObj.content}}
    </div>
    <div class="img-area" v-if="postObj.accessoryList && postObj.accessoryList.length > 0">
      <template v-for="(accessory,index) in postObj.accessoryList">
        <div class="img" :key="index">
          <img :src="resourceUrl(accessory.url)">
        </div>
      </template>
    </div>
    <div class="detail">
      <div class="like" @click="likeClick(postObj)">
        <i class="iconfont icon-pinglun"><img src="@/static/icon/appreciate.svg"></i>
        <span>{{ postObj.likeNum }}</span>
      </div>
      <div class="messge" @click="commentClick(postObj)">
        <i class="iconfont icon-pinglun"><img src="@/static/icon/message.svg"></i>
        <span>{{ postObj.messageNum }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { likeAdd } from '@/api/likeApi'

export default {
  name: 'postComponent',
  props:{
    postObj:{
      type:Object,
    },
    hiddenFlag:{
      type:Boolean,
      default: false
    }
  },
  methods:{
    postClick(){
      this.$emit("click")
    },
    commentClick(postObj){
      let params = {};
      params.postId = postObj.id;
      this.$router.push({ path: '/post', query: params});
    },
    likeClick(postObj){
      let like = {};
      like.type = '2';
      like.businessId = postObj.id;
      likeAdd(like).then(res =>{
        if(res){
          if(res.code == 200){
            postObj.likeNum ++;
            this.$message.success("点赞成功");
          }else if (res.code == 401){
            this.$message.warning("请登录");
          }
        }else {
          this.$message.warning("已经点过赞啦");
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
